import { Spreadsheet } from '@DStypes/project';
import { googleAuthApi, googleSpreadsheetsApi } from '@services/api';

const googleSpreadsheets = googleSpreadsheetsApi.injectEndpoints({
  endpoints: (builder) => ({
    getSheetDetails: builder.query<Spreadsheet, any>({
      query: ({
        spreadsheet_id,
        access_token
      }: {
        spreadsheet_id: string;
        access_token: string;
      }) => ({
        url: `${spreadsheet_id}?fields=properties(title),sheets.properties(sheetId,title)`,
        method: 'GET',
        headers: { Authorization: `Bearer ${access_token}` }
      })
    })
  })
});

const googleAuth = googleAuthApi.injectEndpoints({
  endpoints: (builder) => ({
    exchangeJWTForAccessToken: builder.mutation<any, any>({
      query: (jwtToken) => ({
        url: '/token',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
          assertion: jwtToken
        })
      })
    })
  })
});

export const { useLazyGetSheetDetailsQuery } = googleSpreadsheets;
export const { useExchangeJWTForAccessTokenMutation } = googleAuth;
